import { real_id } from 'src/helpers/interface_helpers';

function deviceIdVariants(id: string): string[] {
	const raw = real_id(String(id || '')).trim();
	const variants = new Set<string>([raw, raw.toLowerCase(), raw.toUpperCase()]);
	try {
		if (/^\d+$/.test(raw)) {
			const hex = BigInt(raw).toString(16);
			variants.add(hex);
			variants.add(hex.toUpperCase());
		} else if (/^[0-9a-f]+$/i.test(raw)) {
			variants.add(BigInt(`0x${raw}`).toString(10));
		}
	} catch {
		// Keep the original id variants when conversion is not possible.
	}
	return [...variants].filter(Boolean);
}

/**
 * Flow/scene often stores real_id (base id) while $devices keys may be suffixed (e.g. id_0).
 */
export const resolveDeviceInStore = (
	devicesMap: Record<string, any>,
	queryId: string,
	channel: number,
): any => {
	if (!queryId) return undefined;
	if (devicesMap[queryId]) return devicesMap[queryId];

	const rid = real_id(queryId);
	const ch = Number.isFinite(channel) ? channel : 0;

	const variants = deviceIdVariants(rid);
	for (const variant of variants) {
		for (const key of [variant, `${variant}_${ch}`, `${variant}_0`]) {
			if (key && devicesMap[key]) return devicesMap[key];
		}
	}

	for (const key of [rid, `${rid}_${ch}`, `${rid}_0`]) {
		if (key && devicesMap[key]) return devicesMap[key];
	}

	for (const d of Object.values(devicesMap)) {
		const dev = d as any;
		if (dev?.id && variants.includes(real_id(String(dev.id)))) {
			return dev;
		}
	}

	return undefined;
};
